import { render } from "./AuthProtocol.vue?vue&type=template&id=5bc5282c&scoped=true"
import script from "./AuthProtocol.vue?vue&type=script&lang=js"
export * from "./AuthProtocol.vue?vue&type=script&lang=js"

import "./AuthProtocol.vue?vue&type=style&index=0&id=5bc5282c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-5bc5282c"

export default script